// Full-screen boot loader — DOM built at top of bundle parse.
// Listens for `app_ready` (Frappe v16 jQuery event) OR a 1.4s cap.

import { soundEngine } from "./sound_engine.js";
import { theme } from "./prefs.js";
import { t } from "../utils/i18n.js";

const MAX_DURATION = 1400;

// Brand-aligned "ERP" loader: a hexagon outline that draws itself, then
// an animated "ERP" wordmark rises into view inside it.
const SVG_MARK = `
<svg viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
	<defs>
		<linearGradient id="e16-loader-grad" x1="0" y1="0" x2="1" y2="1">
			<stop offset="0%" stop-color="var(--e16-accent)" />
			<stop offset="100%" stop-color="var(--e16-accent-light)" />
		</linearGradient>
	</defs>
	<polygon points="44,5 78,25 78,63 44,83 10,63 10,25"
		fill="none" stroke="url(#e16-loader-grad)" stroke-width="2.5" stroke-linejoin="round">
		<animate attributeName="stroke-dasharray" from="0,264" to="264,0" dur="1.05s" fill="freeze" />
	</polygon>
	<text x="44" y="46" text-anchor="middle" dominant-baseline="central"
		font-family="'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif"
		font-size="24" font-weight="800" letter-spacing="0.5"
		fill="url(#e16-loader-grad)">ERP
		<animate attributeName="opacity" values="0;0;1" keyTimes="0;0.45;1" dur="1.1s" fill="freeze" />
		<animateTransform attributeName="transform" type="translate"
			values="0 6;0 6;0 0" keyTimes="0;0.45;1" dur="1.1s" fill="freeze" />
	</text>
</svg>`;

function buildDom() {
	if (document.querySelector(".e16-loader")) return null;
	const lng = theme.currentLang();
	const root = document.createElement("div");
	root.className = "e16-loader";
	root.setAttribute("role", "status");
	root.setAttribute("aria-live", "polite");
	root.innerHTML = `
		<div class="e16-loader__mesh" aria-hidden="true"></div>
		<div class="e16-loader__mark" aria-hidden="true">${SVG_MARK}</div>
		<div class="e16-loader__caption"></div>
		<div class="e16-loader__bar" aria-hidden="true"></div>
	`;
	root.querySelector(".e16-loader__caption").textContent = t("Preparing your workspace…", lng);
	const place = () => (document.body || document.documentElement).appendChild(root);
	if (document.body) place();
	else document.addEventListener("DOMContentLoaded", place, { once: true });
	return root;
}

export const bootLoader = {
	mount() {
		const prefs = (window.frappe && frappe.boot && frappe.boot.e16_prefs) || {};
		if (prefs.enable_loader === 0) return;
		if (window.__e16_loader_shown) return;
		window.__e16_loader_shown = true;

		const reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
		const node = buildDom();
		if (!node) return;

		if (prefs.enable_sounds && !reduce) {
			try { soundEngine.intro(); } catch (e) {}
		}

		const dismiss = () => {
			if (node.classList.contains("is-out")) return;
			node.classList.add("is-out");
			if (prefs.enable_sounds && !reduce) {
				try { soundEngine.outro({ when: 0.05 }); } catch (e) {}
			}
			setTimeout(() => { try { node.remove(); } catch (e) {} }, 360);
		};

		const cap = setTimeout(dismiss, MAX_DURATION);
		const onReady = () => { clearTimeout(cap); dismiss(); };

		const $ = window.jQuery || window.$;
		if ($) $(document).one("app_ready", onReady);
		document.addEventListener("app_ready", onReady, { once: true });
		window.addEventListener("load", () => setTimeout(onReady, 200), { once: true });
	},
};
